import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Datagrid from '../ui/Datagrid';
import columns from './table_config';
import { Grid, IconButton, Tooltip } from '@mui/material';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { renderCell } from '../ui/Datagrid/table_config';
import { archiveRealtimeCollection, downloadRealtimeCollection, downloadRealtimeCSV, listRealtimeCollections } from '../../store/actions/realtimeCollections';
import { AcUnit, Download } from '@mui/icons-material';
import DeleteConfirmationModal from '../deleteConfirmationModal';
import { enqueueSnackbar } from '../../store/actions/snackbar';

const RealtimeCollection = () => {
  const realtimeCollections = useSelector((state) => state.realtimeCollections);

  const apiRef = useGridApiRef();
  const dispatch = useDispatch();

  const [archive, setArchive] = useState({
    collectionName: '',
    open: false
  });

  const handleArchive = (row) => {
    const { name } = row;
    const details = { ...row };
    delete details.grid_id;
    setArchive({
      collectionName: name,
      details,
      open: true
    });
  };

  useEffect(() => {
    const handler = (event) => {
      if (event.data?.type === 'DOWNLOAD_ERROR') {
        dispatch(
          enqueueSnackbar(
              `Download failed: ${event.data.message}`,
              'error',
              Date.now() + Math.random()
          )
        );
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  useEffect(() => {
    if (!realtimeCollections.loading && realtimeCollections.data.length === 0) {
      dispatch(listRealtimeCollections());
    }
  }, []);

  const renderActionCell = ({ row }) => {
    return (
      <Grid container justifyContent="center">
        <Tooltip title={`Download ${row.name}`}>
          <span>
            <IconButton
            variant="solid"
            onClick={() => {
              dispatch(downloadRealtimeCollection(row?.name, row?.active));
            }}
            disabled={realtimeCollections.loading}
          >
            <Download />
          </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={`Archive ${row.name}`}>
          <span>
            <IconButton
            variant="solid"
            onClick={() => { handleArchive(row); }}
            disabled={realtimeCollections.loading || row?.active === false}
          >
            <AcUnit
              sx={{
                color: row?.active === false ? '#CCC' : 'gray'
              }}
             />
          </IconButton>
          </span>
        </Tooltip>
      </Grid>
    );
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <Datagrid
          data={realtimeCollections?.data}
          autoHeight={false}
          columns={columns(renderCell, renderActionCell)}
          loading={realtimeCollections.loading}
          pageSize={100}
          disableStickyHeader={false}
          apiRef={apiRef}
          height={'90vh'}
          getRowId={(row) => row.grid_id}
          serverExport={() => dispatch(downloadRealtimeCSV())}
          toolbar={{
            options: {
              columns: true,
              filters: true,
              density: true,
              export: {
                enabled: true,
                options: true,
                serverExportMode: true
              },
            },
          }}
          sx={{
            '.MuiDataGrid-cell': {
              fontWeight: 'bold',
            },
            '.MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            },
          }}
          initialState={{
            pinnedColumns: {
              left: ['name']
            },
          }}
        />
      </Grid>
      {
        archive.open && <DeleteConfirmationModal
          open={archive.open}
          handleDelete={() => dispatch(archiveRealtimeCollection(archive?.collectionName, archive?.details, () => {
            setArchive({
              collectionName: '',
              open: false
            });
          }))}
          handleClose={() => {
            setArchive({
              collectionName: '',
              open: false
            });
          }}
          actionName='Archive'
          actionDesc={`Are you sure you want to Archive ${archive.collectionName}?`}
        />
      }
    </Grid>
  );
};

export default RealtimeCollection;
